import React from "react";
import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PageHeader from "./PageHeader";

export default function AppsMenu({ user }) {
  const navigate = useNavigate();

  const apps = [
    {
      name: "Juge Boxe",
      description: "Jugement de combat avec parcours smartphone, QR et accès prof.",
      icon: `${process.env.PUBLIC_URL}/assets/ringboxe.jpg`,
      path: "/apps/juge-boxe",
      accent: 'linear-gradient(135deg, #fff1f1 0%, #fff8f8 100%)',
      borderColor: 'rgba(210,83,83,0.16)',
      iconBg: 'linear-gradient(135deg, rgba(210,83,83,0.12) 0%, rgba(255,195,195,0.18) 100%)'
    },
    {
      name: "Carnet Muscu",
      description: "Saisie de séances, carnet élève et gestion des QR par classe.",
      icon: `${process.env.PUBLIC_URL}/assets/muscu_accueil.png`,
      path: "/apps/carnet-muscu",
      accent: 'linear-gradient(135deg, #f4f8ea 0%, #fbfdf5 100%)',
      borderColor: 'rgba(103,143,54,0.16)',
      iconBg: 'linear-gradient(135deg, rgba(103,143,54,0.14) 0%, rgba(190,220,138,0.2) 100%)'
    },
    {
      name: "Badminton",
      description: "Modes de jeu, défis et situations d’apprentissage plus tactiles.",
      icon: `${process.env.PUBLIC_URL}/assets/badminton_logo.png`,
      path: "/apps/badminton",
      accent: 'linear-gradient(135deg, #eef7ff 0%, #f8fbff 100%)',
      borderColor: 'rgba(51,120,220,0.16)',
      iconBg: 'linear-gradient(135deg, rgba(51,120,220,0.12) 0%, rgba(156,205,255,0.2) 100%)'
    }
  ];

  const cardSx = {
    p: { xs: 1.5, sm: 2 },
    borderRadius: { xs: 3, sm: 4 },
    boxShadow: '0 10px 22px rgba(32,24,64,0.08)',
    transition: 'transform 0.18s ease, box-shadow 0.18s ease',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 14px 30px rgba(32,24,64,0.12)'
    }
  };

  return (
    <Box sx={{ px: { xs: 1.25, sm: 3 }, py: { xs: 1.5, sm: 4 }, maxWidth: 1200, mx: "auto" }}>
      <PageHeader
        title="Applications Élèves"
        subtitle="Retrouve directement les applications disponibles pour les usages terrain et les parcours élèves."
        backTo={user ? '/prof' : '/'}
        homeTo="/"
      />

      <Grid container spacing={{ xs: 1.25, sm: 2 }}>
        {apps.map((app) => (
          <Grid item xs={12} sm={6} lg={4} key={app.name}>
            <Paper
              role="button"
              tabIndex={0}
              onClick={() => navigate(app.path)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  navigate(app.path);
                }
              }}
              elevation={0}
              sx={{
                ...cardSx,
                background: app.accent,
                border: `1px solid ${app.borderColor}`
              }}
            >
              <Stack direction="row" spacing={{ xs: 1.25, sm: 1.5 }} alignItems="flex-start">
                <Box
                  sx={{
                    width: { xs: 44, sm: 52 },
                    height: { xs: 44, sm: 52 },
                    borderRadius: { xs: 2.5, sm: 3 },
                    background: app.iconBg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.65)',
                    flexShrink: 0,
                    overflow: 'hidden'
                  }}
                >
                  <Box
                    component="img"
                    src={app.icon}
                    alt={app.name}
                    sx={{
                      width: { xs: 30, sm: 36 },
                      height: { xs: 30, sm: 36 },
                      objectFit: 'contain'
                    }}
                  />
                </Box>

                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 800,
                      mb: 0.35,
                      fontSize: { xs: '0.98rem', sm: '1.12rem' },
                      lineHeight: 1.2
                    }}
                  >
                    {app.name}
                  </Typography>

                  <Typography
                    color="text.secondary"
                    sx={{
                      fontSize: { xs: '0.84rem', sm: '0.95rem' },
                      lineHeight: 1.32
                    }}
                  >
                    {app.description}
                  </Typography>
                </Box>
              </Stack>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}